export const types = {
    FETCH_REQUEST: 'VEHICLES_SEARCH_FETCH_REQUEST',
    FETCH_SUCCESS: 'VEHICLES_SEARCH_FETCH_SUCCESS',
    FETCH_FAILURE: 'VEHICLES_SEARCH_FETCH_FAILURE',

    CLEANUP: 'VEHICLES_SEARCH_CLEANUP',
};


